import React from 'react';

import ReportWidgetCard from './ReportWidgetCard';
import ScheduleDemo from './ScheduleDemo';

const ReachedReportLimit = () => (
  <ReportWidgetCard className="reached-report-limit">
    <div className="reached-report-limit__image" />

    <p className="reached-report-limit__text">
      Report Limit Reached
    </p>

    <ScheduleDemo
      title="Get Started with Apptopia"
      className="reached-report-limit__demo"
    />
  </ReportWidgetCard>
);

export default ReachedReportLimit;
